import { UNREAD_NOTIFICATIONS_COUNT_SUCCESS } from 'constants/action-types/loanRequests/microLoanNotifications';
import notification from 'helpers/notificationHelper';
import apiAction from 'helpers/apiAction';

export default () => dispatch =>
  dispatch(
    apiAction({
      url: `/user/notifications/micro-loan-requests`,
      method: 'GET',
      queries: { status: 'unread' },
      API_REQUEST_SUCCESS: UNREAD_NOTIFICATIONS_COUNT_SUCCESS,
      callbackOnFailure: ({ message }) =>
        notification({ message, status: 'error' }),
      onEnd: () => false,
    }),
  );
